module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hans-Christian Otto","short_name":"hans-christian-otto.de","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/christian-square.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"bc55ad5051627cb0a071c288dcabcd09"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
